<template>
    <div class="container remove-padding-margin">
        <main class="add-padding-default">
            <div class="flex-100">
                <div class="flex-1">
                    <div class="text-alignC mar-top-144"><img src="../../assets/icons/jam_shield-check-f.svg" alt=""></div>
                    <div class="font-16 font-weight-600 color-0000 line-height-25 letter-space-002 text-center mar-top-40">Kata Sandi Berhasil Diubah</div>
                    <div class="color-8080 text-center letter-space-002 line-height-21 font-14">Gunakan kata sandi baru untuk login Smartlink Owner menggunakan email.</div>
                </div>
                <div>
                    <div class="button-lanjut">
                        <button class="btn btn-login btn-long" id="btnsuccess" @click="godetailakun">
                            <span id="textbtnsuccess">Oke</span>
                        </button>
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>

<script>
    export default {
        name: "SuccessChangePassword",
        methods:{
            godetailakun(){
                this.$router.push('/loginowneremail')
            },
        }
    }
</script>

<style scoped>

</style>